module.exports = __webpack_public_path__ + "static/media/IMG_0560.1bd9da6b.JPG";